import { api } from "@/lib/api";

// Offline booking drafts: when an agent/staff submits a booking with no connection,
// the request is kept on this device and auto-submitted once the browser is back online.
const KEY = "ws_booking_drafts";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
const write = (arr) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* storage unavailable — draft lives only for this session */
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("drafts-changed"));
};

export const listDrafts = () => read();
export const draftCount = () => read().length;

export const queueDraft = (payload, meta = {}) => {
  const arr = read();
  const d = {
    id: `d_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    payload,
    meta,
    createdAt: new Date().toISOString(),
  };
  arr.push(d);
  write(arr);
  return d;
};

export const removeDraft = (id) => write(read().filter((d) => d.id !== id));

let syncing = false;
export const syncDrafts = async () => {
  if (syncing || !navigator.onLine) return { sent: 0, dropped: 0 };
  const arr = read();
  if (!arr.length) return { sent: 0, dropped: 0 };
  syncing = true;
  let sent = 0;
  let dropped = 0;
  try {
    for (const d of arr) {
      try {
        await api.post("/bookings", d.payload);
        removeDraft(d.id);
        sent++;
      } catch (e) {
        const st = e?.response?.status;
        // Hard validation rejections (4xx, but not the synthetic offline 0) — drop so the
        // queue never gets stuck forever. Network / 5xx — stop and retry on the next event.
        if (st && st >= 400 && st < 500) {
          removeDraft(d.id);
          dropped++;
        } else {
          break;
        }
      }
    }
  } finally {
    syncing = false;
  }
  return { sent, dropped };
};
